<template>
  <div class="box">
    <div class="head"></div>
    <div class="center">
      <div class="left"></div>
      <div class="middle">
        <div class="search-box">
          <div>
            <div class="search-name">职位名称</div>
            <el-input v-model.trim="queryForm.postInfoName" clearable>
            </el-input>
          </div>
          <div>
            <div class="search-name">专业要求</div>
            <el-input v-model.trim="queryForm.careerRequire" clearable>
            </el-input>
          </div>
          <div>
            <div class="search-name">研究方向</div>
            <el-input v-model.trim="queryForm.researchOrientations" clearable>
            </el-input>
          </div>
          <div class="search-science">
            <div class="search-name">学科名称</div>
            <zr-combobox
              v-model="queryForm.science"
              clearable
              :data-array="scienceTypeArray.concat([{ code: '', name: '' }])"
              value-field="code"
              label-field="name"
              filterable
            >
            </zr-combobox>
          </div>
          <div class="search-edu-require">
            <div class="search-name">学历</div>
            <zr-combobox
              v-model="queryForm.eduRequire"
              clearable
              :data-array="eduTypeArray.concat([{ code: '', name: '' }])"
              value-field="code"
              label-field="name"
            >
            </zr-combobox>
          </div>
          <div class="search-button-box">
            <el-button
              class="search-button"
              type="primary"
              icon="el-icon-search"
              @click="queryData"
              >搜索</el-button
            >
          </div>
        </div>
        <div v-show="isShowDeptDesc">
          <el-card class="box-card">
            <div slot="header" style="padding-bottom: 0px; padding-top: 0">
              <span style="font-size: 25px; font-weight: 600">{{
                deptName + "简介"
              }}</span>
            </div>
            <div
              style="overflow-y: auto; height: auto; white-space: pre-wrap"
              v-text="deptDesc"
            ></div>
          </el-card>
        </div>
        <el-card v-for="post in list" :key="post.id" class="box-card">
          <div class="clearfix" @click="gotoPost(post.id)">
            <template v-if="isPhone()">
              <div class="name">{{ post.name }}</div>
              <div class="science">
                <template v-for="item in post.science.split(',')">
                  <el-tag>{{ item }}</el-tag>
                </template>
              </div>
              <div class="date">
                <el-tag>
                  <div class="begin-date">
                    {{ dateFormat(post.publishDate) }}
                  </div>
                  <div class="end-date">{{ dateFormat(post.endDate) }}</div>
                </el-tag>
              </div>
              <el-button
                class="button-detail"
                type="primary"
                @click="gotoPost(post.id)"
                >查看详情</el-button
              >
            </template>
            <template v-else>
              <div>
                <div class="name">{{ post.name }}</div>
                <div class="science">
                  <template v-for="item in post.science.split(',')">
                    <el-tag>{{ item }}</el-tag>
                  </template>
                </div>
                <div class="date">
                  <div class="begin-date">
                    {{ dateFormat(post.publishDate) }}
                  </div>
                  <div class="end-date">{{ dateFormat(post.endDate) }}</div>
                </div>
              </div>
              <el-button
                class="button-detail"
                type="primary"
                @click="gotoPost(post.id)"
                >查看详情</el-button
              >
            </template>
          </div>
          <div class="required" @click="gotoPost(post.id)">
            <template v-if="isPhone()">
              <template
                v-for="item in post.careerRequire.split(
                  new RegExp(/[,|，|、]/)
                )"
              >
                <el-tag type="danger">{{ item }}</el-tag>
                <div class="gun"></div>
              </template>
              <el-tag type="danger">{{
                eduRequireFormat(post.eduRequire, post.eduRequireAndOver)
              }}</el-tag>
              <div class="gun"></div>
              <el-tag type="danger"
                >{{ post.requireNum > 0 ? post.requireNum + "人" : "人数不限" }}
              </el-tag>
            </template>
            <template v-else>
              <div>
                {{ post.careerRequire }}
              </div>
              <div class="gun">|</div>
              <div>
                {{ eduRequireFormat(post.eduRequire, post.eduRequireAndOver) }}
              </div>
              <div class="gun">|</div>
              <div>
                {{ post.requireNum > 0 ? post.requireNum + "人" : "人数不限" }}
              </div>
            </template>
          </div>
          <div>
            <div class="remark">{{ post.remark }}</div>
          </div>
        </el-card>
      </div>
      <div class="right"></div>
    </div>
    <div class="bottom">
      <el-pagination
        v-if="showPage"
        ref="elPage"
        class="page-box"
        background
        :current-page.sync="currentPage"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        :layout="realLayout"
        :total="total"
        style="float: right; padding-right: 5px"
        @current-change="currentPageChange"
        @size-change="pageSizeChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { defaultPageSizes } from "@/config/settings";
import { getPage } from "@/api/recruit/hr/positionManagement";
import { getDepartmentByDeptCode } from "@/api/recruit/hr/recruitInfo";
import { mapGetters } from "vuex";
import { getBasicData } from "@/api/job/postInfo";

let query = undefined;

export default {
  name: "Index",
  data() {
    return {
      showPage: true,
      deptDesc: "",
      isShowDeptDesc: false,
      isShowDeptCode: "",
      currentPage: 1,
      pageInfo: {},
      filterProps: {
        careerRequire: "",
        postInfoName: "",
        science: "",
        eduRequire: "",
        researchOrientations: "",
        isOnline: "",
      },
      pageSize: 10,
      scienceTypeArray: [],
      eduTypeArray: [],
      queryForm: {
        careerRequire: "",
        postInfoName: "",
        science: "",
        eduRequire: "",
        researchOrientations: "",
      },
      list: [],
      deskPageLayout: "total, sizes, prev, pager, next, jumper",
      mobilePageLayout: "total, sizes, prev, slot, next, jumper",
      pageSizes: defaultPageSizes,
      total: {
        type: Number,
        default: 0,
      },
      pageLayout: {
        type: String,
        default: "total, sizes, prev, pager, next, jumper",
      },
      deptName: "",
      buttonValue: "编辑",
    };
  },
  computed: {
    ...mapGetters({
      device: "settings/device",
    }),
    realLayout() {
      return this.device == "desktop"
        ? this.deskPageLayout
        : this.mobilePageLayout;
    },
  },
  async created() {
    if (this.$route.query.deptCode) {
      this.isShowDeptCode = this.$route.query.deptCode;
      if (this.isShowDeptCode != "") {
        this.isShowDeptDesc = true;
      }
    }
    if (query) {
      this.showPage = false;
      if (query.pageInfo && typeof query.pageInfo == "object") {
        this.currentPage = query.pageInfo.pageIndex;
        this.pageSize = query.pageInfo.pageSize;
      }
      if (query.filterProps && typeof query.filterProps == "object") {
        this.filterProps = query.filterProps;
        this.queryForm.postInfoName = query.filterProps.postInfoName;
        this.queryForm.careerRequire = query.filterProps.careerRequire;
        this.queryForm.science = query.filterProps.science;
        this.queryForm.eduRequire = query.filterProps.eduRequire;
        this.queryForm.researchOrientations =
          query.filterProps.researchOrientations;
      }
      this.$nextTick(() => {
        this.showPage = true;
      });
    }
    await this.loadDeptInfo();
    await this.getScienceArray();
    await this.getEduTypeArray();
    await this.refreshPage();
  },
  beforeRouteEnter(to, from, next) {
    const preName = from.name;
    query = undefined;
    if (preName == "PositionView") {
      query = from.query;
    }
    next();
  },
  methods: {
    isPhone() {
      if (screen.availWidth < 1000) {
        return true;
      }
      return false;
    },
    queryData() {
      this.filterProps.postInfoName = this.queryForm.postInfoName;
      this.filterProps.careerRequire = this.queryForm.careerRequire;
      this.filterProps.science = this.queryForm.science;
      this.filterProps.eduRequire = this.queryForm.eduRequire;
      this.filterProps.researchOrientations = this.queryForm.researchOrientations;
      this.currentPage = 1;
      this.refreshPage();
    },
    //学科类别
    async getScienceArray() {
      let res = await getBasicData({ typeCode: "scienceType" });
      if (res.success) {
        this.scienceTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    //学历分类
    async getEduTypeArray() {
      let res = await getBasicData({ typeCode: "eduRequire" });
      if (res.success) {
        this.eduTypeArray = res.data;
      } else {
        this.$message.error({ showClose: true, message: res.message });
      }
    },
    gotoPost(id) {
      this.$router.push({
        path: "/positionView/index",
        query: {
          positionInfoId: id,
          pageInfo: this.pageInfo,
          filterProps: this.filterProps,
        },
      });
    },
    async currentPageChange(val) {
      this.currentPage = val;
      await this.refreshPage();
    },
    async pageSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      await this.refreshPage();
    },
    async refreshPage() {
      this.showPage = false;
      this.filterProps.isOnline = "1";
      this.pageInfo = {
        pageSize: this.pageSize,
        pageIndex: this.currentPage,
      };
      console.log("this.filterProps", this.filterProps);
      this.pageInfo.filterProps = this.filterProps;
      this.pageInfo.filterProps.deptCode = this.$route.query.deptCode;
      let data = await getPage(this.pageInfo);
      if (data.success) {
        this.list = data.data.data;
        for (let i = 0; i < this.list.length; i++) {
          if (!this.list[i].viewCount) {
            this.list[i].viewCount = 0;
          }
          if (!this.list[i].postCount) {
            this.list[i].postCount = 0;
          }
          if (this.list[i].eduRequire) {
            for (let b in this.eduTypeArray) {
              if (this.eduTypeArray[b].code === this.list[i].eduRequire) {
                this.list[i].eduRequire = this.eduTypeArray[b].name;
              }
            }
          }
          if (this.list[i].science) {
            let scienceList = [];
            try {
              scienceList = JSON.parse(this.list[i].science);
            } catch (error) {
              scienceList = this.list[i].science.split(",");
            }
            let scienceString = "";
            for (let c = 0; c < scienceList.length; c++) {
              for (let j in this.scienceTypeArray) {
                if (this.scienceTypeArray[j].code == scienceList[c]) {
                  scienceString += this.scienceTypeArray[j].name + ",";
                }
              }
            }
            scienceString = scienceString.substr(0, scienceString.length - 1);
            this.list[i].science = scienceString;
          }
        }
        this.total = data.data.total;
      } else {
        this.$message.error({ showClose: true, message: data.message });
      }
      this.$nextTick(() => {
        this.showPage = true;
      });
    },
    async loadDeptInfo() {
      if (this.isShowDeptCode) {
        let data = await getDepartmentByDeptCode({
          deptCode: this.isShowDeptCode,
        });
        if (data.success) {
          this.deptDesc = data.data.remark;
          this.deptName = data.data.name;
        } else {
          this.$message.error({ showClose: true, message: data.message });
        }
      }
    },
    /* doEdit() {
      if (this.buttonValue == "编辑") {
        this.buttonValue = "保存";
      } else if (this.buttonValue == "保存") {
        let flag = this.doSave();
        if (flag) this.buttonValue = "编辑";
      }
    },*/
    eduRequireFormat(value, over) {
      const result = this.eduTypeArray.filter((val) => val.code == value);
      const isover = over === 0 ? "" : "及以上";
      return result[0] ? result[0].name + isover : value + isover;
    },
    dateFormat(value) {
      if (value && typeof value == "string") {
        return value.substr(0, 10);
      } else {
        return value;
      }
    },
  },
};
</script>

<style lang="scss">
@media screen and (min-width: 1000px) {
  @import "public/static/scss/recruit_pc.scss";
}

@media screen and (max-width: 999px) {
  @import "public/static/scss/recruit_phone.scss";
}
</style>
